export default (() => {
  class TopNavigation {
    init() {
      $('.js-dropdown-menu button').on('focus', function() {
        $(this).parents('.js-dropdown-menu').addClass('active');
      }).on('keydown', (e) => {
        if (e.which == 9 && e.shiftKey) {
          $(e.target).parents('.js-dropdown-menu').removeClass('active');
        }
      });

      $('.js-dropdown-menu').on('focus', 'a', function() {
        $(this).parents('.js-dropdown-menu').addClass('active');
      }).on('keydown', 'li:last-child a', (e) => {
        if (e.which == 9 && !e.shiftKey) {
          $(e.target).parents('.js-dropdown-menu').removeClass('active');
        }
      });
    }
  }

  class CompareCourse {
    constructor(inputSelector, modalTextSelector) {
      this.$compareLink = $(inputSelector);
      this.$modalTextContainer = $(modalTextSelector);
    }

    init() {
      let _self = this;

      // Show save course counter on page load
      _self.renderSavedCourseCounter();

      // Handle compare link click
      _self.$compareLink.on('click', function(e) {
        //e.preventDefault();

        let courseCode = $(this).attr('data-course-code');
        let storedCourses = getStoredCompareCoursesArray();
        if(storedCourses.length > 0 && storedCourses.includes(courseCode)) {
          _self.$modalTextContainer.html(`<h3>This course is already on your list</h3>
          <p>Visit <a href="/my-saved-courses" target="_blank">My saved courses</a> to view and compare your list of saved courses.</p>`);
        } else if(storedCourses.length >= 10) {
          _self.$modalTextContainer.html(`<h3>You can only save 10 courses at a time</h3>
          <p>Visit <a href="/my-saved-courses" target="_blank">My saved courses</a> to remove courses from your current list.</p>`);
        } else {
          addCourseToCompare(courseCode);
          _self.renderSavedCourseCounter();
          _self.$modalTextContainer.html(`<h3>Course Saved</h3>
          <p>You've saved this course for later. Visit <a href="/my-saved-courses" target="_blank">My saved courses</a> to view and compare your list of saved courses.</p>`);
        }
      });
    }

    renderSavedCourseCounter() {
      let saveCourses = getStoredCompareCoursesArray();
      if(saveCourses.length > 0) {
        $('span.saved-courses-counter').remove()
        $('[data-saved-courses-counter] > a').html($('[data-saved-courses-counter] > a').html() + '<span class="saved-courses-counter">' + saveCourses.length + '</span>')
      }
    }
  }

  const topNavigation = new TopNavigation();
  topNavigation.init();
  const compareCourse = new CompareCourse('#course-compare-cta-add', '[data-course-compare-text]');
  compareCourse.init();
})()
